import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as XLSX from 'xlsx';
import {
  DownloadTemplateSheetConfig,
  TemplateColumnConfig,
} from '../../models/template-column-config';

@Component({
  selector: 'app-upload-template',
  templateUrl: './upload-template.component.html',
  styleUrls: ['./upload-template.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class UploadTemplateComponent {
  @Input() columns: TemplateColumnConfig[] = [];
  @Input() sheets: DownloadTemplateSheetConfig[] = [];
  /** When true with multi-sheet config, every tab in the workbook is parsed (not only configured names). */
  @Input() readEntireWorkbook = false;
  @Input() accept: string = '.xlsx';
  @Output() dataParsed = new EventEmitter<any>();
  /** Emits the raw ArrayBuffer of the uploaded file so consumers can extract embedded images. */
  @Output() fileBuffer = new EventEmitter<ArrayBuffer>();

  fileName = '';

  onFileChange(event: any, fileInput: HTMLInputElement) {
    const file = event.target.files[0];
    if (!file) return;
    this.fileName = file.name;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const rawBuffer: ArrayBuffer = e.target.result;
      this.fileBuffer.emit(rawBuffer);

      const data = new Uint8Array(rawBuffer);
      const workbook = XLSX.read(data, { type: 'array' });

      let result: any = {};

      // Multi-sheet mode
      if (this.sheets && this.sheets.length > 0) {
        if (this.readEntireWorkbook) {
          workbook.SheetNames.forEach((name) => {
            const ws = workbook.Sheets[name];
            if (ws) {
              result[name] = XLSX.utils.sheet_to_json(ws, { header: 1 });
            }
          });
        } else {
          this.sheets.forEach((sheetConfig) => {
            const ws = workbook.Sheets[sheetConfig.name];
            if (ws) {
              const json = XLSX.utils.sheet_to_json(ws, { header: 1 });
              result[sheetConfig.name] = json;
            }
          });
        }
      }
      // Single-sheet mode
      else if (this.columns && this.columns.length > 0) {
        const sheetName = workbook.SheetNames[0];
        const ws = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(ws, { header: 1 });
        result[sheetName] = json;
      }

      this.dataParsed.emit(result);

      fileInput.value = '';
    };
    reader.readAsArrayBuffer(file);
  }
}
